export { default as dicBenefits } from './dicBenefits';
export { treatmentPages } from './treatmentPages';
export { default as nursingHome } from './nursingHome';
